import { Component, Input } from '@angular/core';

@Component({
    selector: 'bw-icon-bounds-legacy',
    template: `
    <div class="icon-bounds" [ngStyle]="{'background': bgColor}"><ng-content></ng-content></div>
  `,
    styleUrls: ['./icon-bounds.component.scss'],
    standalone: false
})
export class IconBoundsComponentLegacy {

  @Input() bgColor = 'var(--bg-gray)';

}
